// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.pagecontents {
    height: 100%;
}

.machine-status-dashboard {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #f1f3f6;
    overflow: hidden;
}

/* Ensure background remains solid in fullscreen */
.machine-status-dashboard:fullscreen {
    background-color: #f1f3f6;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
}

/* Premium Header Styles (Aligned with NewDeviceOee) */
.dashboard-header-premium {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(250, 250, 250, 0.85);
    backdrop-filter: blur(10px);
    padding: 0.7rem 2rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.header-left-premium {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.header-date-premium {
    font-size: 14px;
    font-weight: 600;
    color: #222;
    letter-spacing: 0.2px;
}

.header-shift-premium {
    font-size: 13px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 8px;
    background: #fff;
    border-left: 4px solid #FFA500;
    color: #333;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    display: inline-block;
}

.customer-title-premium {
    font-size: 20px !important;
    font-weight: 800 !important;
    color: #111;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.header-right-premium {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.filter-select-premium {
    min-width: 160px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
}

.filter-select-premium .MuiOutlinedInput-root {
    border-radius: 10px;
}

.filter-select-premium .MuiOutlinedInput-root:hover fieldset {
    border-color: #FFA500;
}

.filter-select-premium .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: #FFA500;
    border-width: 1.5px;
}

.filter-select-premium .MuiInputLabel-root {
    font-weight: 600;
    color: #666;
}

.filter-select-premium .MuiInputLabel-root.Mui-focused {
    color: #FFA500;
}

.filter-select-premium .MuiSelect-select {
    font-weight: 600;
    color: #222;
}

/* Status Summary Bar */
.status-summary-bar {
    display: flex;
    justify-content: space-around;
    padding: 15px;
    background: #ffffff !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    margin-bottom: 10px;
}

.summary-item {
    text-align: center;
    padding: 0 20px;
    border-right: 1px solid #eee;
}

.summary-item:last-child {
    border-right: none;
}

.summary-label {
    font-size: 12px !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    color: #777;
    letter-spacing: 1px;
}

.summary-value {
    font-size: 24px !important;
    font-weight: 900 !important;
    color: #1a1a1a;
}

.summary-item.running .summary-value { color: #2e7d32; }
.summary-item.idle .summary-value { color: #f1a014; }
.summary-item.alarm .summary-value { color: #d32f2f; }
.summary-item.locked .summary-value { color: rgb(243, 44, 130); }
.summary-item.disconnect .summary-value { color: #757575; }

/* Content */
.dashboard-content {
    flex: 1 1;
    overflow-y: auto;
    padding-bottom: 40px;
}

/* Minimal Card Styles */
.machine-card-minimal {
    height: 130px;
    border-radius: 16px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: none !important;
    position: relative;
    overflow: hidden;
}

.machine-card-minimal:hover {
    filter: brightness(1.05);
}

.machine-name-minimal-centered {
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-size: 1.1rem !important;
    opacity: 1;
    text-align: center;
    width: 100%;
    margin-bottom: 4px;
}

.center-value {
    font-weight: 900 !important;
    letter-spacing: -1px;
    font-size: 2.2rem !important;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.2);
    line-height: 1 !important;
}

/* Alarm Animation - Pulse Background */
@keyframes pulse-bg {
    0% { background-color: #d32f2f; }
    50% { background-color: #f44336; }
    100% { background-color: #d32f2f; }
}

.alarm-blink-bg {
    animation: pulse-bg 1.5s infinite ease-in-out;
}

.loading-indicator {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: #fff;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

@media (max-width: 1024px) {
    .dashboard-header-premium {
        flex-direction: column;
        gap: 15px;
    }
    .status-summary-bar {
        flex-wrap: wrap;
        gap: 10px;
    }
    .summary-item {
        border-right: none;
        flex: 1 1 30%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/MachineStatusDashboard/MachineStatusDashboard.css"],"names":[],"mappings":";;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA,uCAAuC,cAAc,EAAE;AACvD,oCAAoC,cAAc,EAAE;AACpD,qCAAqC,cAAc,EAAE;AACrD,sCAAsC,wBAAwB,EAAE;AAChE,0CAA0C,cAAc,EAAE;;AAE1D,YAAY;AACZ;IACI,SAAO;IACP,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,iDAAiD;IACjD,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,4BAA4B;IAC5B,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA,uCAAuC;AACvC;IACI,KAAK,yBAAyB,EAAE;IAChC,MAAM,yBAAyB,EAAE;IACjC,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,eAAe;QACf,SAAS;IACb;IACA;QACI,kBAAkB;QAClB,aAAa;IACjB;AACJ","sourcesContent":["\n\n.pagecontents {\n    height: 100%;\n}\n\n.machine-status-dashboard {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background-color: #f1f3f6;\n    overflow: hidden;\n}\n\n/* Ensure background remains solid in fullscreen */\n.machine-status-dashboard:fullscreen {\n    background-color: #f1f3f6;\n    width: 100vw;\n    height: 100vh;\n    overflow-y: auto;\n}\n\n/* Premium Header Styles (Aligned with NewDeviceOee) */\n.dashboard-header-premium {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: rgba(250, 250, 250, 0.85);\n    backdrop-filter: blur(10px);\n    padding: 0.7rem 2rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.header-left-premium {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.header-date-premium {\n    font-size: 14px;\n    font-weight: 600;\n    color: #222;\n    letter-spacing: 0.2px;\n}\n\n.header-shift-premium {\n    font-size: 13px;\n    font-weight: 600;\n    padding: 4px 12px;\n    border-radius: 8px;\n    background: #fff;\n    border-left: 4px solid #FFA500;\n    color: #333;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n    display: inline-block;\n}\n\n.customer-title-premium {\n    font-size: 20px !important;\n    font-weight: 800 !important;\n    color: #111;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n\n.header-right-premium {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.filter-select-premium {\n    min-width: 160px;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);\n}\n\n.filter-select-premium .MuiOutlinedInput-root {\n    border-radius: 10px;\n}\n\n.filter-select-premium .MuiOutlinedInput-root:hover fieldset {\n    border-color: #FFA500;\n}\n\n.filter-select-premium .MuiOutlinedInput-root.Mui-focused fieldset {\n    border-color: #FFA500;\n    border-width: 1.5px;\n}\n\n.filter-select-premium .MuiInputLabel-root {\n    font-weight: 600;\n    color: #666;\n}\n\n.filter-select-premium .MuiInputLabel-root.Mui-focused {\n    color: #FFA500;\n}\n\n.filter-select-premium .MuiSelect-select {\n    font-weight: 600;\n    color: #222;\n}\n\n/* Status Summary Bar */\n.status-summary-bar {\n    display: flex;\n    justify-content: space-around;\n    padding: 15px;\n    background: #ffffff !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;\n    margin-bottom: 10px;\n}\n\n.summary-item {\n    text-align: center;\n    padding: 0 20px;\n    border-right: 1px solid #eee;\n}\n\n.summary-item:last-child {\n    border-right: none;\n}\n\n.summary-label {\n    font-size: 12px !important;\n    font-weight: 800 !important;\n    text-transform: uppercase;\n    color: #777;\n    letter-spacing: 1px;\n}\n\n.summary-value {\n    font-size: 24px !important;\n    font-weight: 900 !important;\n    color: #1a1a1a;\n}\n\n.summary-item.running .summary-value { color: #2e7d32; }\n.summary-item.idle .summary-value { color: #f1a014; }\n.summary-item.alarm .summary-value { color: #d32f2f; }\n.summary-item.locked .summary-value { color: rgb(243, 44, 130); }\n.summary-item.disconnect .summary-value { color: #757575; }\n\n/* Content */\n.dashboard-content {\n    flex: 1;\n    overflow-y: auto;\n    padding-bottom: 40px;\n}\n\n/* Minimal Card Styles */\n.machine-card-minimal {\n    height: 130px;\n    border-radius: 16px !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n}\n\n.machine-card-minimal:hover {\n    filter: brightness(1.05);\n}\n\n.machine-name-minimal-centered {\n    font-weight: 800 !important;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    font-size: 1.1rem !important;\n    opacity: 1;\n    text-align: center;\n    width: 100%;\n    margin-bottom: 4px;\n}\n\n.center-value {\n    font-weight: 900 !important;\n    letter-spacing: -1px;\n    font-size: 2.2rem !important;\n    text-shadow: 1px 1px 3px rgba(0,0,0,0.2);\n    line-height: 1 !important;\n}\n\n/* Alarm Animation - Pulse Background */\n@keyframes pulse-bg {\n    0% { background-color: #d32f2f; }\n    50% { background-color: #f44336; }\n    100% { background-color: #d32f2f; }\n}\n\n.alarm-blink-bg {\n    animation: pulse-bg 1.5s infinite ease-in-out;\n}\n\n.loading-indicator {\n    position: fixed;\n    bottom: 24px;\n    right: 24px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 50%;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n@media (max-width: 1024px) {\n    .dashboard-header-premium {\n        flex-direction: column;\n        gap: 15px;\n    }\n    .status-summary-bar {\n        flex-wrap: wrap;\n        gap: 10px;\n    }\n    .summary-item {\n        border-right: none;\n        flex: 1 1 30%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
